import { render, staticRenderFns } from "./SvgEndScreen.vue?vue&type=template&id=72acda7b&scoped=true&"
import script from "./SvgEndScreen.vue?vue&type=script&lang=js&"
export * from "./SvgEndScreen.vue?vue&type=script&lang=js&"
import style0 from "./SvgEndScreen.vue?vue&type=style&index=0&id=72acda7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72acda7b",
  null
  
)

export default component.exports